import { createAction } from '../utils';
import { ZoneType } from './types';
export var setZoneName = createAction(ZoneType.SET_NAME);
export var setZonePoint = createAction(ZoneType.SET_POINT);
